import React, {useState} from 'react';
import Box from "@mui/material/Box";
import {TextField} from "@mui/material";
import DateTimeInput from "../../../../components/UI/filter/DateTimeInput";
import DateTimeUtil from "../../../../utils/common/DateTimeUtil";
import IssuanceService from "../../../../API/orders/prodaction.issueedge/issuance/IssuanceService";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import ButtonCreate from "../../../../components/UI/button/ButtonCreate";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {constantsErrorMessages} from "../../../../Constants";
import dayjs from "dayjs";
import MaterialWarehouseService from "../../../../API/orders/warehouse/material/MaterialWarehouseService";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import InStockTable from "./InStockTable";
import ButtonExport from "../../../../components/UI/button/ButtonExport";
import FileDownloadController from "../../../../API/organization/FileDownloadController";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {InStockTableFilterData} from "../../../../data/FilterTables/InStockTableFilterData";

const InWork = () => {
        const [startInWork, setStartInWork] = useState(dayjs(Date.now()));
        const [dataInWork, setDataInWork] = useState(null);
        const [dataAllWork, setDataAllInWork] = useState([]);
        const [alertData, setAlertData] = useState({});
        const [reportReceived, setReportReceived] = useState(false);
        const [filteredData, setFilteredData] = useState(dataAllWork)
        const [globalFilter, setGlobalFilter] = useState('');
        const [columnsFilter, setColumnsFilter] = useState([]);
        const [tableOptions, setTableOptions] = useState({
            pageIndex: 0,
            pageSize: 100,
            totalElements: 0,
            searchData: ""
        })
        const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
            const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
            const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

            const data = [...prevData]
            const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, InStockTableFilterData) : data
            const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
                return calcFilterData(accumulator, currentValue?.value, [InStockTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
            }, globalFilterData);

            setFilteredData(newData)

            tableOptionsHandle({
                ...tableOptions,
                totalElements: newData.length,
                pageSize: pageSize ? pageSize : tableOptions?.pageSize
            })

            if (isColumnFilters) {
                setColumnsFilter(searchQuery)
            } else {
                setGlobalFilter(searchQuery || "")
                if (searchQuery !== globalFilter) {
                    EditLocalStoragePagesData(`/organization/in-work`, "searchQuery", searchQuery)
                }
            }
        }

        const getStartPageSize = () => {
            const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
            const pageSize = pagesData[`/organization/in-work`]?.pageSize
            const searchQuery = pagesData[`/organization/in-work`]?.searchQuery

            return {searchQuery, pageSize}
        }

        const tableOptionsHandle = (nextState, currTab) => {
            setTableOptions(nextState)
            if (nextState.pageSize !== tableOptions.pageSize) {
                EditLocalStoragePagesData(`/organization/in-work`, "pageSize", nextState.pageSize)
            }
        }
        const applyInWork = () => {
            IssuanceService.getInWork(DateTimeUtil.convertToJavaDateTime(startInWork)).then(function (response) {
                const data = response.data;
                setDataInWork(data);
                handleModalAlert("Вычислено", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }
        const handleModalAlert = (message, type = "error") => {
            setAlertData({
                type: type,
                open: true,
                message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
            })
        }

        const applyAllInWork = () => {
            const {searchQuery, pageSize} = getStartPageSize()
            MaterialWarehouseService.getAllInWork(DateTimeUtil.convertToJavaDateTime(startInWork)).then(function (response) {
                const data = response.data;
                setDataAllInWork(data);
                setReportReceived(true)
                handleSearchQuery(searchQuery, data, pageSize)
                handleModalAlert("Отчёт получен", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        return (
            <Box sx={{padding: "0 30px"}}>
                <BreadcrumbsComponent
                    page={"В работе"}
                    path={[
                        {name: "Главная", href: "/"},
                    ]}/>
                <Typography sx={{fontSize: "24px", fontWeight: 700}}>
                    В работе
                </Typography>
                <Box sx={{display: "flex", gap: "50px", paddingTop: "30px"}}>
                    <Box sx={{display: "flex", gap: "20px", alignItems: "end"}}>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: '0.5rem',
                                flexWrap: 'wrap',
                                alignItems: "end"
                            }}
                        >
                            <DateTimeInput
                                value={startInWork}
                                setValue={setStartInWork}
                                variant={"outlined"}
                            />
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '0.5rem',
                                    flexWrap: 'wrap',
                                }}
                            >
                                <ButtonCreate
                                    text={"Вычислить в работе"}
                                    onClick={applyInWork}
                                    icon={false}
                                    width={180}
                                    disabled={!startInWork}/>
                            </Box>
                        </Box>

                        <TextField
                            size={"small"}
                            margin="none"
                            key={"base"}
                            label={"В базовой валюте"}
                            variant="standard"
                            name={"base"}
                            disabled={true}
                            value={dataInWork === null ? "" : dataInWork.first.toFixed(2)}
                        />
                        <TextField
                            size={"small"}
                            margin="none"
                            key={"alternative"}
                            label={"В Альтернативной валюте"}
                            variant="standard"
                            name={"base"}
                            disabled={true}
                            value={dataInWork === null ? "" : dataInWork.second.toFixed(2)}
                        />

                    </Box>
                </Box>
                <Box sx={{padding: "30px 0", display: 'flex', gap: "10px",}}>
                    <ButtonCreate
                        text={"Получить полный отчёт"}
                        onClick={applyAllInWork}
                        icon={false}
                        width={200}
                        disabled={!startInWork}/>
                    <ButtonExport
                        text={"Скачать отчёт"}
                        width={130}
                        api={() => FileDownloadController.exportMaterialsInWork(DateTimeUtil.convertToJavaDateTime(startInWork))}
                        handleModalAlert={handleModalAlert}/>
                </Box>
                <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                    return {...alert, open: false}
                })}/>
                {reportReceived &&
                    <InStockTable
                        data={dataAllWork}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        globalFilter={globalFilter}
                        filteredData={filteredData}
                        handleSearchQuery={handleSearchQuery}
                        columnsFilter={columnsFilter}/>}
            </Box>
        );
    }
;

export default InWork;